export * from '@primeuix/themes/aura/inputnumber';
export { default } from '@primeuix/themes/aura/inputnumber';
